import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useDivision} from "../context/DivisonContext";

const DivisionSelection = () => {
    const { setDivision } = useDivision();
    const [selectedDivision, setSelectedDivision] = useState('');
    const navigate = useNavigate();

    const handleDivisionSelect = () => {
        console.log("HandleDivisonSelect => ", selectedDivision);

        if (selectedDivision) {
            setDivision(selectedDivision);
            localStorage.setItem('userDivision', selectedDivision);
            navigate('/dashboard');
        }
    };

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <div className="flex flex-col items-center justify-center gap-4 p-6 m-3 bg-white shadow-md rounded-lg w-full max-w-xs">
                <img
                    className="h-8 w-auto mb-4 cursor-pointer"
                    src="https://static.wixstatic.com/media/9d90f3_e5e08befbf554451a60099a1e5907fbc~mv2.png"
                    alt="CUREosity"
                />
                <h2 className="text-lg font-semibold">Select Your Division</h2>
                <select
                    className="input bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={selectedDivision}
                    onChange={(e) => setSelectedDivision(e.target.value)}
                >
                    <option value="">Select a division</option>
                    <option value="HR">HR</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Sales">Sales</option>
                    {/* Add more divisions as needed */}
                </select>
                <button
                    onClick={handleDivisionSelect}
                    className="mt-2 bg-green-700 text-white px-4 py-2 rounded hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default DivisionSelection;
